<template lang="pug">
.k-booking-card-confirmed
  k-booking-card-base(:booking="booking" :other-user="otherUser" :hide-menu="hideMenu")
    template(v-slot:dropdown)
      template(v-if="cancelable")
        .pb-2
          nuxt-link(:to="booking.rescheduleBookingLink").unstyled--link.brand-pink--text.paragraph--small Reschedule
        .pb-2
          a(
            @click.prevent="$emit('cancel', booking)"
            href="#"
          ).paragraph--small.unstyled--link.brand-pink--text Cancel and send message
    v-col.shrink.k-booking-card-confirmed__calendar
      .k-booking-card-confirmed__calendar-content
        .font-weight-bold.small-caps--small.uppercase {{ startTimeForTz.format('ddd') }}
        k-card(flat).brand-grey
          .title--semi-large.font-weight-bold.white--text.my-1 {{ startTimeForTz.format('DD') }}
        .font-weight-bold.small-caps--small {{ startTimeForTz.format('MMM') }}
    //- Mobile
    v-col.grow.hidden-sm-and-up.ml-5
      .paragraph--small.mb-1 {{ startTimeForTz.format('h:mm') }} - {{ endTimeForTz.format('h:mm a')}}
      .paragraph--book.font-weight-bold.mb-2 {{ otherUser.fullName }}
      .small-caps--small.hidden-sm-and-up(:class="isAdvisorOfBooking ? 'brand-dark-aqua--text' : 'brand-light-pink--text'") {{ isAdvisorOfBooking ? 'You\'re advising' : 'You\'re learning' }}
      k-booking-join-button(
        :booking="booking"
      ).mt-4
    v-col.hidden-xs-only
      .d-flex.align-center
        k-icon(color="brand-grey").pr-3 time
        .paragraph--small {{ startTimeForTz.format('h:mm') }} - {{ endTimeForTz.format('h:mm a')}}
    v-col.hidden-xs-only
      .d-flex.align-center
        //- User avatar
        k-user-avatar(:src="isAdvisorOfBooking ? booking.learner.avatarUrl : booking.advisor.avatarUrl" :size="24").mr-3
        //- User name and booking info
        .paragraph--book.font-weight-bold {{ otherUser.fullName }}
    v-col.hidden-xs-only
      k-chip(
        :color="isAdvisorOfBooking ? 'brand-light-aqua-30' : 'brand-grey-20'"
        :text-color="isAdvisorOfBooking ? 'brand-dark-aqua' : 'brand-pink'"
        small
      ) {{ isAdvisorOfBooking ? 'You\'re advising' : 'You\'re learning' }}
    v-col.hidden-xs-only
      k-booking-join-button(
        :booking="booking"
      )
</template>
<script>
import { UsesAuthenticatedUser } from '@/mixins'

export default {
  mixins: [
    UsesAuthenticatedUser
  ],
  props: {
    booking: {
      type: Object,
      required: true,
    },
    hideMenu: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    startTimeForTz () {
      return this.authenticatedUser.utcToMyTz(this.booking.bookingStartTimeUtc)
    },
    endTimeForTz () {
      return this.authenticatedUser.utcToMyTz(this.booking.bookingEndTimeUtc)
    },
    isAdvisorOfBooking () {
      return this.booking.advisorId === this.authenticatedUser.id
    },
    otherUser () {
      if (this.isAdvisorOfBooking) {
        return this.booking.learner
      }
      return this.booking.advisor
    },
  },
}
</script>

<style lang="scss" scoped>
.k-booking-card-confirmed {
  &__calendar-content {
    height: 100%;
  }

  &__calendar {
    min-width: 78px !important;
    text-align: center;
  }
}
</style>
